// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"84617884","623":"bde53c92","942":"f0123cf6","977":"26f27bd9"}[chunkId] + ".chunk.js";
};